/**
 * Created by razial on 18.09.2026.
 */

PassLevelsConfig.buildpass = [
    {
        energy: 0,
        task: {
            goal: 30
        },
        reward: {
            unit: { code: "worker", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 0, amount: 1 }
        }
    }, // 1
    {
        energy: 5,
        task: {
            goal: 75
        },
        reward: {
            unit: { code: "herochest", stage: 0, amount: 1 },
            stickers2BrownPack: 1
        },
        premiumReward: {
            unit: { code: "sacks", stage: 0, amount: 2 },
            stickers2BluePack: 1
        }
    }, // 2
    {
        energy: 5,
        task: {
            goal: 150
        },
        reward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 2 }
        }
    }, // 3
    {
        energy: 5,
        task: {
            goal: 350
        },
        reward: {
            unit: { code: "sacks", stage: 0, amount: 1 },
            stickers2BrownPack: 1
        },
        premiumReward: {
            unit: { code: "worker", stage: 3, amount: 2 },
            stickers2BluePack: 1
        }
    }, // 4
    {
        energy: 10,
        task: {
            goal: 700
        },
        reward: {
            unit: { code: "crystal", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 2, amount: 1 }
        }
    }, // 5
    {
        energy: 10,
        task: {
            goal: 1500
        },
        reward: {
            unit: { code: "worker", stage: 2, amount: 1 },
            stickers2GreenPack: 1
        },
        premiumReward: {
            unit: { code: "worker", stage: 4, amount: 1 },
            stickers2BluePack: 1
        }
    }, // 6
    {
        energy: 10,
        task: {
            goal: 3000
        },
        reward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 1, amount: 2 }
        }
    }, // 7
    {
        energy: 15,
        task: {
            goal: 5000
        },
        reward: {
            unit: { code: "worker", stage: 3, amount: 1 },
            stickers2GreenPack: 1
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 2 },
            stickers2VioletPack: 1
        }
    }, // 8
    {
        energy: 15,
        task: {
            goal: 8000
        },
        reward: {
            unit: { code: "treasure", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "coinstree", stage: 1, amount: 1 }
        }
    }, // 9
    {
        energy: 15,
        task: {
            goal: 12000
        },
        reward: {
            unit: { code: "magicplant", stage: 4, amount: 1 },
            stickers2BluePack: 1
        },
        premiumReward: {
            unit: { code: "energytree", stage: 2, amount: 1 },
            stickers2RedPack: 1
        }
    } // 10
];
